// A mobile app record carries the full storage path of each image it captured, in
// `storage_paths`. Older records carry bare file names in `front_images`/`back_images` that
// live under images/, the same shape a unit record uses. Returns the path of the image that
// stands for the record, or null when it captured none.
export function getAppRecordImagePath(recordData) {
    if (!recordData || typeof recordData !== 'object') return null;

    const storagePaths = Array.isArray(recordData.storage_paths) ? recordData.storage_paths : [];
    const firstPath = storagePaths.find((path) => typeof path === 'string' && path.trim());
    if (firstPath) return firstPath.trim();

    const legacyNames = [
        ...(Array.isArray(recordData.front_images) ? recordData.front_images : []),
        ...(Array.isArray(recordData.back_images) ? recordData.back_images : []),
    ];
    const firstName = legacyNames.find((name) => typeof name === 'string' && name.trim());

    return firstName ? `images/${firstName.trim()}` : null;
}
